import React from 'react';
import { useAuth } from './Auth';

export function withAuth(Component) {
  const name = Component.displayName || Component.name || 'Component';
  function AuthWrapper({ children, ...rest }) {
    const auth = useAuth();

    return (
      <Component {...rest} auth={auth}>
        {children}
      </Component>
    );
  }

  AuthWrapper.displayName = `withAuth(${name})`;

  return AuthWrapper;
}
